if (!customElements.get('foria-product-carousel')) {
  customElements.define('foria-product-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.carousel || !window.EmblaCarousel) return;
      this.viewport = this.querySelector('[data-carousel-viewport]');
      this.dots = this.querySelector('[data-carousel-dots]');
      const track = this.querySelector('[data-carousel-track]');
      const originals = [...track.children];
      this.count = originals.length;
      // A second cycle guarantees loop coverage even with only four products and three visible columns.
      if (this.count > 1) originals.forEach(slide => {
        const copy = slide.cloneNode(true);
        copy.dataset.carouselCopy = '';
        copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        track.append(copy);
      });
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.carousel = EmblaCarousel(this.viewport, { loop: true, align: 'start', slidesToScroll: 1, duration: 35 });
      this.updateDots = () => {
        const selected = this.carousel.selectedScrollSnap() % this.count;
        this.dots.querySelectorAll('button').forEach((button, index) => {
          button.setAttribute('aria-current', String(index === selected));
        });
      };
      this.buildDots = () => {
        this.dots.replaceChildren();
        Array.from({ length: this.count }).forEach((_, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'foria-home__carousel-dot';
          button.setAttribute('aria-label', `Ver producto ${index + 1}`);
          button.addEventListener('click', () => {
            this.carousel.scrollTo(index, this.motion.matches);
            this.play();
          });
          this.dots.append(button);
        });
        this.dots.hidden = this.carousel.scrollSnapList().length < 2;
        this.updateDots();
      };
      this.carousel.on('select', this.updateDots).on('reInit', this.buildDots);
      this.carousel.on('pointerDown', () => this.pause());
      this.carousel.on('pointerUp', () => this.play());
      this.addEventListener('mouseenter', () => this.pause(), options);
      this.addEventListener('mouseleave', () => this.play(), options);
      this.addEventListener('focusin', () => this.pause(), options);
      this.addEventListener('focusout', () => setTimeout(() => this.play(), 0), options);
      document.addEventListener('visibilitychange', () => this.play(), options);
      this.motion.addEventListener('change', () => this.play(), options);
      this.buildDots();
      this.play();
    }
    play() {
      this.pause();
      if (!this.carousel || this.motion.matches || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
      // Previous snap moves products left to right through the loop boundary.
      this.timer = setInterval(() => this.carousel.scrollPrev(), Number(this.dataset.autoplayInterval) || 4500);
    }
    pause() { clearInterval(this.timer); }
    disconnectedCallback() {
      this.pause();
      this.events?.abort();
      this.carousel?.destroy();
      this.querySelectorAll('[data-carousel-copy]').forEach(node => node.remove());
      this.carousel = null;
    }
  });
}
